import createMatcher from 'feather-route-matcher';
import Notification from './components/notifications';
import Tour from './components/tour';

const hookMatcher = createMatcher({
  '/fields/:id/disease/downy_mildew_primary': async () => {
    const { default: DownyPrimary } = await import('~/liveview/components/downy_primary');
    return { DownyPrimary };
  },
  '/fields/:id/disease/downy_mildew': async () => {
    const { default: Downy } = await import('~/liveview/components/downy_secondary');
    const { default: DownyInc } = await import('~/liveview/components/downy_inc');
    return { Downy, DownyInc };
  },
  '/fields/:id/treatments': async () => {
    const { default: ActionWindow } = await import('~/liveview/components/action-window');
    // search select is needed for in case of a post request and form error
    const { default: SearchSelect } = await import('~/liveview/components/search_select');
    return { ActionWindow, SearchSelect };
  },
  '/fields/:id/treatments/new': async () => {
    const { default: SearchSelect } = await import('~/liveview/components/search_select');
    return { SearchSelect };
  },
  '/fields/:id/treatments/:treatmentId/edit': async () => {
    const { default: SearchSelect } = await import('~/liveview/components/search_select');
    return { SearchSelect };
  },
  '/fields/:id/treatments/:treatmentId': async () => {
    // search select is needed for in case of a post request and form error
    const { default: SearchSelect } = await import('~/liveview/components/search_select');
    return { SearchSelect };
  },
  '/treatment_templates/:id': async () => {
    // search select is needed for in case of a post request and form error
    const { default: SearchSelect } = await import('~/liveview/components/search_select');
    return { SearchSelect };
  },
  '/devices/:id/analytics': async () => {
    const { default: AnalyticsChart } = await import('~/liveview/components/analytics-chart');
    const { default: RainBy } = await import('~/liveview/components/rain-by');

    return { AnalyticsChart, RainBy };
  },
  '/devices/:field_id/alerts': async () => {
    const { default: NotificationPopup } = await import('~/liveview/components/push-notifications-popup');
    return { NotificationPopup };
  },
  '/devices/:field_id/alerts/:id/edit': async () => {
    const { default: NotificationPopup } = await import('~/liveview/components/push-notifications-popup');
    return { NotificationPopup };
  },
  '/devices/:field_id/alerts/new': async () => {
    const { default: NotificationPopup } = await import('~/liveview/components/push-notifications-popup');
    return { NotificationPopup };
  },
  '/console': async () => {
    const { default: DiseaseMap } = await import('~/liveview/components/disease_map');
    return { DiseaseMap };
  },
  '/fields/:id': async () => {
    const { default: GddChart } = await import('~/liveview/components/gdd-chart');
    return { GddChart };
  }
});

export default async () => {
  let hooks = {
    // Default hooks that are used on every route
    Notification, Tour,
  };
  const match = hookMatcher(window.location.pathname);
  if (match && match.value) {
    const currentRouteHooks = await match.value();
    hooks = { ...hooks, ...currentRouteHooks };
    console.debug('Loaded hooks: ', hooks);
  }
  return hooks;
};
